var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoSandglassGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#D3D4D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1693 7.24023L10.9493 11.0002H10.9093L8.81934 7.24023H13.1693Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0395 11.0014L14.4695 6.67141C14.7295 6.09141 14.2995 5.44141 13.6595 5.44141H8.32952C7.69952 5.44141 7.26952 6.09141 7.51952 6.67141L9.94952 11.0014L7.51952 15.3314C7.26952 15.9114 7.69952 16.5614 8.32952 16.5614H13.6595C14.2995 16.5614 14.7295 15.9114 14.4695 15.3314L12.0395 11.0014ZM8.81952 7.24141H13.1695L10.9495 11.0014L10.9295 11.0414L10.9095 11.0014L8.81952 7.24141ZM9.04952 15.8814L11.0595 13.9414L12.9395 15.8814H9.04952Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9302 11.04L10.9102 11H10.9502L10.9302 11.04Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9398 15.8814H9.0498L11.0598 13.9414L12.9398 15.8814Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 3.30078H7.2998V4.44078H14.6998V3.30078Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6998 17.5605H7.2998V18.7005H14.6998V17.5605Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9398 15.8814H9.0498L11.0598 13.9414L12.9398 15.8814Z",
    fill: "#D3D4D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1693 7.24023L10.9493 11.0002L10.9293 11.0402L10.9093 11.0002L8.81934 7.24023H13.1693Z",
    fill: "#D3D4D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSandglassGrey);
export default __webpack_public_path__ + "static/media/picto_sandglass_grey.01c504100b227fc22418275865582b2a.svg";
export { ForwardRef as ReactComponent };